

export class MobileMenu extends HTMLElement {
    
    constructor() {
        super();
        
        
        this.selectors = {
            classes: {
                header: 'site-header',
                mobileMenu: 'mobile-menu',
                mobileMenuButton: 'site-header__mobile-menu-button',
                mobileMenuOpen: 'mobile-menu-open',
                mobileMenuPage: 'mobile-menu__page',
                mobileMenuLinkItem: 'link-item',
                mobileMenuPageActive: 'mobile-menu__page-active',
                predictiveSearch: 'predictive-search-section',
                scrollLock: 'scroll-lock',
            }
        };
        
        
        this.interacted = false;
    }
    
    // Mobile Menu Initialised / Added to DOM
    connectedCallback() {
        // console.log('🚀🚀🚀 MOBILE MENU INITIALISED...', this );
        
        // Main Elements
        this.siteHeader = document.querySelector(`.${ this.selectors.classes.header }`);
        this.mobileMenuButton = document.querySelector(`.${ this.selectors.classes.mobileMenuButton }`);
        this.predictiveSearch = document.querySelector(`.${ this.selectors.classes.predictiveSearch }`);
        
        this.init();        
        
    }
    
    // Mobile Menu Removed from DOM
    disconnectedCallback() {
        // console.log("Mobile Menu removed from page.");
    }
    
    
    init() {
        document.addEventListener('click', this.handleEvent.bind(this));
        
        this.setMobileMenuHeight();
        this.toggleMobileMenuResize();
    }
    
    handleEvent(e) {
        // console.log('🚀 CLICK TARGET: ', e.target );
        
        this.toggleMobileMenu(e);
        this.handleMenuItemClick(e);
    }
    
    
    toggleMobileMenu(e) {
        const target = e.target;
        
        if (! this ) {
            return;
            
        } else if ( target.closest(`.${ this.selectors.classes.mobileMenuButton }`) ) {
            // console.log('CLICKED MOBILE MENU BUTTON', this.mobileMenuButton );
            if ( this.classList.contains( this.selectors.classes.mobileMenuOpen ) ) this.close();
            else this.open();
            
        } else if (  this.classList.contains( this.selectors.classes.mobileMenuOpen ) &&
                    !target.closest(`.${ this.selectors.classes.mobileMenu }`) &&
                    !target.closest(`.${ this.selectors.classes.header }`)
        ) {
            this.close();
            
        }
    }
    
    open() {
        // Load Mobile Images on first interaction
        if ( !this.interacted ) {
            this.loadMobileMenuImages();
            this.interacted = true;
        }
        
        if ( this.classList.contains( this.selectors.classes.mobileMenuOpen ) ) {
            return
            
        } else {
            this.goToPage(0);
            this.setMobileMenuHeight();
            this.classList.add( this.selectors.classes.mobileMenuOpen );
            this.mobileMenuButton.classList.add( this.selectors.classes.mobileMenuOpen );
            this.lockScrolling( true );
            // console.log('✅✅✅ Opening Mobile Menu...');
        }
    }
    
    close() {
        if ( !this.classList.contains( this.selectors.classes.mobileMenuOpen ) ) {
            return
        } else {
            this.lockScrolling( false );
            this.classList.remove( this.selectors.classes.mobileMenuOpen );
            this.mobileMenuButton.classList.remove( this.selectors.classes.mobileMenuOpen );
            this.goToPage(0);
            // console.log('❌❌❌ Close Mobile Menu...');
        }
    }
    
    toggleMobileMenuResize() {
        const mediaQuery = window.matchMedia('(max-width: 1024px)');
        
        const handleMediaChange = (e) => {
            if (e.matches) {
                // Add class when media query matches
            } else {
                // Remove class when media query doesn't match
                if ( this.classList.contains( this.selectors.classes.mobileMenuOpen ) ) {
                    this.close();
                }
            }
        };
        
        handleMediaChange( mediaQuery );
        mediaQuery.addEventListener('change', handleMediaChange);
    }
    
    handleMenuItemClick(e) {
        if ( e.target.classList.contains( this.selectors.classes.mobileMenuLinkItem ) ) {
            // console.log('LINK ITEM CLICKED!');
            const linkItem = e.target;
            const linkTargetId = linkItem.dataset.targetMenuId;
            
            if ( linkTargetId ) {
                this.goToPage( linkTargetId );
            }
        }
    }
    
    goToPage( pageId ) {
        const targetPage = this.querySelector(`.${ this.selectors.classes.mobileMenuPage }[data-menu-id="${ pageId }"]`);
        if ( targetPage ) {
            this.closeAllPages();
            
            this.openPage( targetPage );
            this.currentPage = targetPage;
        }
    }
    
    openPage( targetPage ) {
        if ( targetPage ) {
            
            if ( this.predictiveSearch ) this.predictiveSearch.close();
            
            targetPage.classList.add( this.selectors.classes.mobileMenuPageActive );
        }
    }
    
    closePage( targetPage ) {
        if ( targetPage ) {
            targetPage.classList.remove( this.selectors.classes.mobileMenuPageActive );
        }
    }
    
    closeAllPages() {
        const mobileMenuPages = this.querySelectorAll(`.${ this.selectors.classes.mobileMenuPage }`);
        if ( mobileMenuPages && mobileMenuPages.length > 0 ) {
            mobileMenuPages.forEach( mobileMenuPage => {
                this.closePage( mobileMenuPage )
            });
        }
    }
    
    // Helper Method - Locks Page Scrolling
    lockScrolling( shouldLock = false ) {
        if ( shouldLock == true ) {
            document.body.classList.add( this.selectors.classes.scrollLock );
        } else {
            document.body.classList.remove( this.selectors.classes.scrollLock );
        }
    }
    
    setMobileMenuHeight() {
        if ( this.siteHeader ) {
            const headerBottom = this.siteHeader.getBoundingClientRect().bottom;
            const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
            const menuHeight = viewportHeight - headerBottom;
            
            this.style.maxHeight = `${menuHeight}px`;
        }
    }
    
    
    loadMobileMenuImages() {
        const mobileMenuImages = this.querySelectorAll(`img[data-src]`);
        
        if ( !mobileMenuImages.length ) return;
        
        // console.log('✅ Loading Mobile Menu Images...', mobileMenuImages );
        mobileMenuImages.forEach( img => {
            this.loadImage( img );
        });
        
    }
    
    
    
    loadImage( img ) {
        const dataSrc = img.dataset.src;
        
        if ( !dataSrc ) return;
        
        img.src = dataSrc;
        img.removeAttribute('data-src');
    }
    
    
}

customElements.define('mobile-menu', MobileMenu);